import React from 'react';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  TextField,
} from '@mui/material';
import { DocumentStateContext, DocumentDispatchContext } from '../../context/DocumentContext';
import SvgIconNote from '../../images/icons/Note_icon.svg?react';

interface Props {}

const DocumentAddNoteModal: React.FC<Props> = (props) => {
  const { openAddNoteModal } = React.useContext(DocumentStateContext);
  const dispatch = React.useContext<React.Dispatch<any>>(DocumentDispatchContext);

  return (
    <Dialog
      id="create-extraction-batch-dialog"
      maxWidth="md"
      open={openAddNoteModal}
      PaperProps={{
        style: { border: '1px solid #BDC3D2' },
      }}
      onClose={(e, reason) => {
        dispatch({ type: 'TOGGLE_ADD_NOTE_MODAL' });
      }}
      aria-labelledby="form-dialog-title"
    >
      <DialogTitle id="form-dialog-title" data-cy="form-dialog-title">
        <SvgIconNote style={{ maxHeight: '18px' }} /> Add Note
      </DialogTitle>
      <DialogContent>
        <Grid container spacing={6}>
          <Grid container alignItems="center" item xs={12} data-cy="modal-extraction-batch-name">
            <TextField
              id="standard-multiline-flexible"
              // label="Note"
              multiline
              // maxRows={4}
              // variant="filled"
              style={{
                width: '300px',
                border: '1px solid #BDC3D2',
                borderRadius: 6,
                background: 'white',
              }}
              // value={value}
              // onChange={handleChange}
            />
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions
        style={{
          marginTop: '2em',
        }}
      >
        <Button
          id="create-extraction-batch-dialog-next"
          data-cy="create-extraction-batch-dialog-next"
          variant="contained"
          color="primary"
        >
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DocumentAddNoteModal;
